import * as React from 'react'
import { Label } from '../atoms/Label'
import { uniqueId } from '../utils/uniqueId'

interface IProps {
  id?: string
  label: React.ReactNode
  children: (id: string) => React.ReactNode
  [key: string]: any
}

export class WithLabel extends React.PureComponent<IProps, {}>{
  public id: string

  public componentWillMount() {
    this.id = this.props.id || uniqueId('with-label-')
  }

  public render() {
    const { children, id, label, ...rest } = this.props

    return (
      <>
        <Label htmlFor={this.id} {...rest}>{label}</Label>
        {children(this.id)}
      </>
    )
  }
}



// WEBPACK FOOTER //
// ./src/molecules/WithLabel.tsx